import axios from 'axios'
import { getSignal } from './abortManager'

const getBaseURL = () => {
    if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL
    if (process.env.NODE_ENV === 'production') return 'https://securitylecs.com'
    // Dev: stessa macchina che serve il frontend, porta 6002 (HTTP in dev)
    return `http://${window.location.hostname}:6002`
}

const api = axios.create({
    baseURL: getBaseURL()
})

api.interceptors.request.use((config) => {
    if (!config.signal) {
        config.signal = getSignal()
    }
    return config
})

api.interceptors.response.use(
    (response) => response,
    (error) => {
        return Promise.reject(error)
    }
)

export const getCsrfToken = async () => await api.get(`/api/csrf-token`, {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const checkUser = async () => await api.get(`/api/auth/`, {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const login = async (payload) => await api.post(`/api/auth/login`, payload, {
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
})

export const logout = async () => await api.post(`/api/auth/logout`,{}, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const get_lecs = async () => await api.get(`/api/home/lecs`, {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getSingleHighOrCriticalDetail = async (payload) => await api.get(`/api/security/single`, {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})


export const get_user_options = async () => await api.get(`/api/options/user`, {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})


export const set_lecs = async (payload) => await api.post(`/api/auth/set`,payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})


export const get_home_graph = async (payload, signal) => await api.get('/api/home/graph', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal
})

export const dataGrid_home = async () => await api.get('/api/security/alerts', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getLecsStatus = async (signal) => await api.get('/api/home/status', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal
})

export const getLicense = async (signal) => await api.get('/api/home/license', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal
})

export const getPercentile = async (signal) => await api.get('/api/home/percentile', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal
})

export const getNotification = async () => await api.get('/api/home/notify', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    }
})

export const getRating = async (payload, signal) => await api.get('/api/home/rating', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal
})

export const recordSecurityScoreHistory = async (payload) => await api.post('/api/home/security-score-history', payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const getSecurityScoreHistory = async () => await api.get('/api/home/security-score-history', {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getAlert = async (payload) => await api.get('/api/security/alerts', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getAnomalies = async (payload) => await api.get('/api/security/anomalies', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getCritical = async (payload) => await api.get('/api/security/critical', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const postTelegram = async (payload) => await api.post(`/api/options/telegram`,payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})
export const setTime = async (payload) => await api.post(`/api/options/set-time`,payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const  postCreateTicket = async (payload) => await api.post(`/api/options/create-ticket`,payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getDeviceOptions = async (payload) => await api.get('/api/options/device', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getUserOptions= async (payload) => await api.get('/api/options/user', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getHosts = async (payload) => await api.get('/api/options/hosts',{
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getNetworkHosts = async (payload) => await api.get('/api/network/hosts',{
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getNetworkHostsV2 = async (payload) => await api.get('/api/network/hostsV2',{
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const postPrefHost = async (payload) => await api.post('/api/network/hosts', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const postMachineHost = async (payload) => await api.post('/api/network/hosts/set-machine', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getDelayed= async (payload) => await api.get('/api/network/hosts/delayed', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const  postThreshold = async (payload) => await api.post(`/api/network/threshold`, payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getRealTime = async (payload) => await api.get('/api/network/real-time', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getMaxMinPps = async (payload) => await api.get('/api/network/max-min-pps', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getMaxMinBps = async (payload) => await api.get('/api/network/max-min-bps', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getBpsGraphic = async (payload) => await api.get('/api/network/bpsGraphic', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getInfrastructure = async (payload) => await api.get('/api/network/infrastructure',{
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getAnalysis = async (payload) =>  await api.get('/api/network/analysis', {
    params: payload, 
    withCredentials: true,
    headers: { 
    'Content-Type': 'application/json'
    }
})


export const getAnalysisDetail = async (payload, signal) => await api.get('/api/network/analysis',{
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

export const getContentIA = async (payload) => await api.get(`/api/security/detail` , {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})


export const getBroadcast = async (payload) => await api.get('/api/network/broadcast',{
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})


export const getBroadcastDetail = async (payload, signal) => await api.get('/api/network/broadcast', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal
})

export const getBroadcastLogs = async (payload, signal) => await api.get('/api/network/broadcast-logs', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal
})



//OK FUNZIONA PAYLOAD NEI PARAMETRI PARAMS= PAYLOAD
export const getHighlightsHome = async (payload) => await api.get('/api/home/highlights',{
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getExternalIps = async () => await api.get('/api/security/get-external-ips',{
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})


export const getHighlights = async (payload) => await api.get('/api/security/highlights',{
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})


//OK FUNZIONA PAYLOAD NEI PARAMETRI PARAMS= PAYLOAD
export const getDataUsers = async (payload) => await api.get('/api/home/profile',{
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getInternalDetection = async (payload) => await api.get('/api/security/internal-detection',{
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getInternalDetectionDetail = async (payload) => await api.get('/api/security/internal-detection',{
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const updateNotify = async (payload, signal) => await api.post('/api/options/update-notify/', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})
export const getThreatIntelligence = async (payload) => await api.get('/api/security/threat-intelligence',{
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getThreatIntelligenceDetail = async (payload, signal) => await api.get('/api/security/threat-intelligence',{
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

export const getTiresiaHighlights = async (payload) => await api.get('/api/tiresia/highlights',{
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getTiresiaTrend = async (payload) => await api.get('/api/tiresia/trends',{
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getTiresiaEntropy = async (payload) => await api.get('/api/tiresia/entropy',{
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getTiresiaEntropyTable = async (payload) => await api.get('/api/tiresia/entropy-table',{
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getMap = async (payload, signal) => await api.get('/api/extra/map', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal
})

export const getMapDetail = async (CountrySelected) => await api.get('/api/extra/map?iso='+CountrySelected,{
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

/*export const getIpList = async (payload, signal) => await api.get('/api/tiresia/ip_list', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})*/
export const getIpList = async (payload, signal) => await api.get('/api/assets/ip-list', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

export const getChartsData = async (payload, signal) => await api.get('/api/assets/charts-data', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})
export const setMachineName = async (oid, machine_name) => await api.post('api/assets/set-machine-name', { oid, machine_name }, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

// Manual correction of scan-populated identity fields (vendor, vlan,
// classification.asset_type.value, os.family/version/build, device.firmware,
// zone.name/purdue_level) when the scan got it wrong. The server keeps the
// authoritative allow-list — see EDITABLE_ASSET_FIELDS in assets-ctrl.mjs.
// `fields` should only include keys the user actually changed.
export const updateAssetFields = async (oid, fields) => await api.post('/api/assets/update-fields', { oid, fields }, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

// MIB per asset (TASK-AI-030, API di test — verrà rifatta). Un asset può
// avere più MIB in parallelo, ognuno un documento a sé; niente Content-Type
// esplicito sull'upload, axios imposta multipart/form-data + boundary da
// solo passando un FormData.
export const uploadMib = async (assetId, file) => {
    const form = new FormData()
    form.append('assetId', assetId)
    form.append('file', file)
    return await api.post('/api/assets/mib/upload', form, { withCredentials: true })
}

export const getMibsForAsset = async (assetId) => await api.get(`/api/assets/mib/${assetId}`, { withCredentials: true })

// Import massivo asset da file CSV/JSON (pagina Inventory) -- stesso pattern
// FormData di uploadMib sopra, niente Content-Type esplicito.
export const importAssets = async (file) => {
    const form = new FormData()
    form.append('file', file)
    return await api.post('/api/assets/import', form, { withCredentials: true })
}

export const saveMibFieldSelection = async (mibId, selectedFields) => await api.post(`/api/assets/mib/${mibId}/select-fields`, { selectedFields }, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const deleteMib = async (mibId) => await api.delete(`/api/assets/mib/${mibId}`, { withCredentials: true })

// Override manuale Orion: pin/clear di OS family/version/build e classification.
// Il backend risponde entro ~5s (publish + attesa ack MQTT); il timeout HTTP client
// va tenuto sopra i 5s del timer server, altrimenti scarta risposte valide.
export const orionManualOverride = async (payload) => await api.post('/api/assets/orion-manual-override', payload, {
    timeout: 25000,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const getIpDetail = async (payload, signal) => await api.get('/api/tiresia/ip_search',{
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

// Conduit host-a-host (client/server/servizio+porta) per la tab "Connections"
// dell'asset detail -- vedi TASK-AI-024, sostituisce getIpDetail solo li'.
export const getConduits = async (payload, signal) => await api.get('/api/zones/conduits', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

export const getAssetExposure = async (payload, signal) => await api.get('/api/zones/asset-exposure', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

// Conduit zona-a-zona IEC 62443 (allowed/not-allowed) e gap Security Level
// (SL-T vs SL-A) per zona -- pagina di rete "Network Zones", TASK-AI-031.
export const getZoneConduits = async (payload, signal) => await api.get('/api/zones/zone-conduits', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

export const getZoneStats = async (payload, signal) => await api.get('/api/zones/zone-stats', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

export const getHistoryTickets = async (payload) => await api.get('/api/options/tickets', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getResellerInfo = async (payload) => await api.get('/api/options/reseller-info', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getOnlineLecs = async (payload) => await api.get('/api/options/get-online-lecs', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const post2FA = async (payload) => await api.post(`/api/auth/2fa`,payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})


export const postCurrentCustomer = async (payload) => await api.post(`/api/customers/set`,payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getCustomerFeatures = async () => await api.get('/api/customers/features', {
    withCredentials: true,
})

export const getCustomerTotalDet = async (payload) => await api.get('/api/home/attacks', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getResGlobalAttack = async (payload) => await api.get('/api/home/global-graph', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getNattackType = async (payload) => await api.get('/api/home/attacks', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const postSwitchToggle = async (payload) => await api.post('/api/options/behavioral',payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getCustomers = async (payload) => await api.get('/api/customers/', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getCustomerHighLights = async (payload) => await api.get('/api/home/customer-highlights', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})




export const postChangeName = async (payload) => await api.post(`/api/options/change-name`,payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})
export const postRegister = async (payload) => await api.post(`/api/auth/register`,payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getNFR = async (payload) => await api.get('/api/customers/nfr', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})


export const getLocalAdmins = async (type) => await api.get('/api/customers/local-admin', {
    params: type,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})


export const addAdminUser = async (payload) => await api.post(`/api/customers/local-admin/add`, payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const delAdminUser = async (payload) => await api.post(`/api/customers/local-admin/del`, payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})


export const updateLocalAdmin = async (payload) => await api.post(`/api/customers/lecs/local-admin`, payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getLocalAdminLecs = async (payload) => await api.get(`/api/customers/lecs/local-admin`, {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getVerifyPage = async (payload) => await api.get('/api/auth/2fa', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})


export const setCurrentCustomer = async (payload) => await api.post(`/api/customers/set`,payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const putCustomerDel= async (payload) => await api.put(`/api/customers/nfr/del`, payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})
export const putTicketState= async (payload) => await api.put(`/api/options/change-tickets`, payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const changeHardwareTicketPhases = async (payload) => await api.put(`/api/options/change-tickets-phase`, payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})



export const getTicketsRes = async (payload) => await api.get('/api/options/tickets', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getTicketsResDetail = async (idTicket) => await api.get('/api/options/tickets?id='+idTicket, {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})


export const reqForgotPassword = async (payload) => await api.post('/api/auth/passwordResetRequest', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getPasswordResetPage = async (payload) => await api.get('/api/auth/passwordResetPage', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})


export const resetPassword = async (payload) => await api.post('/api/auth/passwordReset', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getDownloadPdf = async (payload) => await api.get('/api/options/download-pdf', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    responseType:'blob'
})

export const getPDFList = async (payload) => await api.get('/api/options/res-pdf', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})


export const postResend2FA = async (payload) => await api.post(`/api/auth/2fa/resend`,payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})
export const postSoppressEvent = async (payload) => await api.post(`/api/options/event-supp`,payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})




export const putNewLicense= async (payload) => await api.put(`/api/options/update-license`, payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const addLecs = async (payload, signal) => await api.post(`/api/options/add-lecs`, payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})
export const postAddIcosLecs = async (payload) => await api.post(`/api/customers/add-ic`,payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getLecsAccounts = async () => await api.get(`/api/customers/lecs/accounts`, {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})



export const getDetailCouple = async (payload, signal) => await api.get('/api/tiresia/ip_detail', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})


export const getIpServices = async (payload) => await api.get('/api/tiresia/services', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getAdvancedData = async (payload, signal) => await api.get('/api/tiresia/test', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})
export const getHigh = async (payload) => await api.get('/api/security/high', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getTimeZone = async () => await api.get('/api/options/get-time', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getThreat = async (payload) => await api.get('/api/security/threat', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const addAccount = async (payload) => await api.post(`/api/options/add-account`,payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})


export const getSecondaryAccount = async (payload) => await api.get('/api/options/get-secondary', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getResType = async (payload) => await api.get('/api/home/res-type', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getIcosLecs = async (payload) => await api.get('/api/customers/get-ic', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getIsolationForest = async (payload) => await api.get('/api/tiresia/isolation_forest', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const deleteSelectedLECS = async (payload) => await api.put('/api/options/delete-account', payload, { 
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getChangeLog = async (payload) => await api.get('/api/options/user/changelog', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const setStaticIp = async (payload) => await api.post('/api/config/set-static-ip', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const setChangeLog = async (payload) => await api.post(`/api/options/user/set-changelog`,payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})
export const setBackground = async (payload) => await api.post(`/api/options/user/set-background`,payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const setPrivacy = async (payload) => await api.post(`/api/options/user/privacy`, payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getPrivacy = async () => await api.get('/api/options/user/privacy', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getIpInspection = async (payload) => await api.get('/api/extra/ip-inspection', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getAllLecsView = async (payload) => await api.get('/api/home/global-data-lecs', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getSuppRules = async (payload) => await api.get('/api/security/get-supp', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const setSuppLecs= async (payload) => await api.post('/api/security/supp-lecs', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const delSuppressedEvent= async (payload) => await api.post('/api/options/del-supp', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getClassificationOfIPByDetection = async (payload) => await api.get('/api/tiresia//ip_classification_by_detection', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getSingleDetailofType2and3 =async (payload, signal) => await api.get('/api/options/details', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})
export const getSuppressedEventsofType2and3 =async (payload) => await api.get('/api/options/event-supp', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getSecurityLog =async (payload, signal) => await api.post('/api/security/security-log', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

export const getSuppressionSuggestions = async (payload, signal) => await api.post('/api/security/suppression-suggestions', payload, {
    signal,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getSuppressionSuggestionDetail = async (payload, signal) => await api.post('/api/security/suppression-suggestions/detail', payload, {
    signal,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getSuppressionSuggestionEvents = async (payload, signal) => await api.post('/api/security/suppression-suggestions/events', payload, {
    signal,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const previewBulkAck = async (payload, signal) => await api.post('/api/security/suppression-suggestions/ack/preview', payload, {
    signal,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const bulkAck = async (payload) => await api.post('/api/security/suppression-suggestions/ack', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const undoBulkAck = async (payload) => await api.post('/api/security/suppression-suggestions/ack/undo', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getNoiseFilters = async (params, signal) => await api.get('/api/security/noise-filters', {
    params,
    signal,
    withCredentials: true,
})

export const saveNoiseFilters = async (payload) => await api.post('/api/security/noise-filters', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getIncidentsByIp = async (payload, signal) => await api.post('/api/security/incidents-by-ip', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

export const getLecsInfoByReseller = async (payload) => await api.get('/api/customers/get-lecs-info', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getAllLecsStatusReseller = async (payload) => await api.get('/api/customers/get-lecs-status', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getAllIntelligenceReseller = async (payload) => await api.get('/api/customers/get-all-intelligence', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getProtocolAnalyzer = async (payload) => await api.get('/api/tiresia/protocol-analyzer', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getHeatMapData = async (payload) => await api.get('/api/security/get-data-heatmap', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})


export const generatePDFReseller = async (payload, signal) => await api.post('/api/options/generate-report', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    responseType: 'blob',
    signal: signal
})

export const getHardwareTickets = async (payload) => await api.get('/api/options/tickets-hardware', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})
export const getProbeMode = async (payload) => await api.get('/api/security/get-probe-mode', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getTiresia = async (payload, signal) => await api.get('/api/tiresia/tiresia', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})
export const getTiresiaLevel = async (signal) => await api.get('/api/tiresia/tiresia-level', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal
})
export const getTiresiaNetwork = async (payload) => await api.get('/api/tiresia/tiresia-network', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const createHardwareTickets = async (payload) => await api.post('/api/options/create-hardware-ticket', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})


export const askChangeLecs = async (payload) => await api.post('/api/options/change-hardware', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})


export const setWhitelist = async (payload) => await api.post('/api/config/set-whitelist', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getWhitelist = async () => await api.get('/api/options/whitelist', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getNotificationOfflineLecs = async (payload) => await api.get('/api/options/notifications-offline-lecs', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})


export const addLecsReseller = async (payload) => await api.post('/api/customers/add-lecs', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})


export const activateLecs = async (payload) => await api.post('/api/customers/activate-license', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getWeeklyDataLecs = async (payload) => await api.post(`/api/home/multi-lecs-view`, payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getLogsBySerial = async (params) => await api.get('/api/customers/get-logs-by-serial', {
    params: params,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const GetNetworkList = async () => await api.get('/api/home/network-all-lecs-list', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const setProtection = async (payload) => await api.post('/api/options/client-protection', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getProtection = async () => await api.get('/api/options/client-protection' , {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const setAck= async (payload) => await api.post('/api/security/ack-log', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const setAckEvent = async (payload) => await api.post('/api/config/ack-event', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getSettings = async () => await api.get('/api/options/settings', {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const saveSettings = async (payload) => await api.post('/api/options/settings', payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const getCustomersLicenses = async () => await api.get('/api/customers/licenses', {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})


export const addAccountLecs= async (payload) => await api.post('/api/customers/add-account', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const delAccountLecs= async (payload) => await api.post('/api/customers/del-account', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const deleteUser = async (params) => await api.get('/api/options/remove-account', {
    params: params,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const deleteTicket = async (payload) => await api.post('/api/options/remove-ticket', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const deleteCustomer = async (payload) => await api.post('/api/options/remove-CustomerReseller', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const updateCustomer = async (payload) => await api.post('/api/options/update-CustomerReseller', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})


export const getPayloadDetails = async (payload) => await api.get('/api/security/detail', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getTiresiaScans = async (payload) => await api.get('/api/tiresia/tiresia-scans', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getHighlightsIp = async () => await api.get('/api/security/highlights-ip', {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const checkCommercial = async () => await api.get('/api/auth/check-commercial', {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const changePassword = async (payload) => await api.post('/api/auth/change-password', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const sendEmailPrivacy = async (payload) => await api.post('/api/auth/sendEmailPrivacy', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const chatBotAI = async (payload) => await api.get('/api/tiresia/tiresia-chatbot', {
    params: payload, 
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const addInfoReport= async (payload) => await api.post('/api/customers/add-infoReport', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const checkInfoReport = async (payload) => await api.get('/api/customers/checkInfoReport', {
    params: payload, 
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const updateInfoReport= async (payload) => await api.post('/api/customers/update-infoReport', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const AddImageReseller= async (payload) => await api.post('/api/home/res-img', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const GetImageReseller= async () => await api.get('/api/home/get-res-img' , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getAuthenticatorCode = async () => await api.get('/api/options/get-auth-code' , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const checkCode = async (code) => await api.post('/api/options/check-code', code , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const SendEmailCode = async (payload) => await api.post('/api/auth/sendEmailCode', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const deleteInfoReport= async (payload) => await api.post('/api/customers/delete-infoReport', payload , {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
})

export const getRecentHost = async (payload) => await api.get('/api/assets/get-recent-host', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getNewDiscoveries = async ({ from, to }) => await api.get('/api/assets/new-discoveries', {
    params: { from, to },
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const setPref = async (oid) => await api.post('/api/assets/set-pref', { oid }, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const setMachine = async (ip) => await api.post('/api/assets/set-machine', { ip }, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const deleteMachineName = async (oid) => await api.delete('/api/assets/delete-machine-name', {
    data: { oid },
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

// ─── Zones ────────────────────────────────────────────────────────────────────

export const getZones = async () => await api.get('/api/zones', {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

// Zones are protected by the same jwtCheck chain as every other authenticated
// route, which includes validateRequestFields (middlewareBody.mjs) — it rejects
// the whole request with 400 if ANY body key is null or ''. Note is optional and
// zone_id is null when unassigning, so both must be OMITTED rather than sent empty.
// target_sl/purdue_level sono opzionali (preparazione TASK-AI-031, mockup
// manuale in attesa del push di configurazione reale verso Orion) -- omessi
// se non impostati, così non forzano le zone create prima che questi campi
// esistessero. purdue_level qui è la stima manuale ("estimated"): appena
// Orion vede davvero la zona, il valore derivato dagli asset ("actual")
// prende il sopravvento lato dashboard (vedi getZoneStats) -- le due cose
// non vanno confuse.
const orionOptionalFields = ({ target_sl, purdue_level, subnets, vlans }) => ({
    ...(target_sl !== undefined && target_sl !== null && target_sl !== "" ? { target_sl } : {}),
    ...(purdue_level !== undefined && purdue_level !== null && purdue_level !== "" ? { purdue_level } : {}),
    ...(subnets !== undefined ? { subnets } : {}),
    ...(vlans !== undefined ? { vlans } : {}),
})

export const createZone = async ({ name, note, risk, target_sl, purdue_level, subnets, vlans }) => await api.post('/api/zones', { name, risk, ...(note ? { note } : {}), ...orionOptionalFields({ target_sl, purdue_level, subnets, vlans }) }, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const updateZone = async (id, { name, note, risk, target_sl, purdue_level, subnets, vlans }) => await api.put(`/api/zones/${id}`, { name, risk, ...(note ? { note } : {}), ...orionOptionalFields({ target_sl, purdue_level, subnets, vlans }) }, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const deleteZone = async (id) => await api.delete(`/api/zones/${id}`, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const assignZone = async (zone_id, assetIds) => await api.post('/api/zones/assign', zone_id ? { zone_id, assetIds } : { assetIds }, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

// Regole "conduit permesso" zona-a-zona dichiarate a mano (TASK-AI-031) --
// sotto-risorsa di /api/zones, mockup in attesa del push reale verso Orion.
export const getConduitRules = async () => await api.get('/api/zones/conduit-rules', {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

// service/note vanno omessi quando vuoti anziché inviati come "" -- il
// middleware globale validateRequestFields rigetta con 400 qualsiasi body
// con un campo null/"" (stesso vincolo documentato per CVE-ack sotto).
export const createConduitRule = async ({ zone_a, zone_b, service, allowed, direction, note }) => await api.post('/api/zones/conduit-rules', { zone_a, zone_b, allowed, direction, ...(service ? { service } : {}), ...(note ? { note } : {}) }, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const updateConduitRule = async (id, { zone_a, zone_b, service, allowed, direction, note }) => await api.put(`/api/zones/conduit-rules/${id}`, { zone_a, zone_b, allowed, direction, ...(service ? { service } : {}), ...(note ? { note } : {}) }, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const deleteConduitRule = async (id) => await api.delete(`/api/zones/conduit-rules/${id}`, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

// Spinge zone/regole verso Orion sul sensore (TASK-AI-031 fase 2) --
// timeout lungo lato client per allineare quello lato server (attesa
// dell'ack del firmware dopo il deploy Zeek, non hot-reload).
export const pushOrionConfig = async () => await api.post('/api/zones/push-orion-config', {}, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
    timeout: 62000,
})

// ─── CVE acknowledgment ───────────────────────────────────────────────────────
// origin is null for host/firmware-level CVEs — omit it rather than sending null,
// same validateRequestFields constraint documented on the Zones endpoints above.

export const getCveAcks = async () => await api.get('/api/cve-ack', {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const acknowledgeCve = async ({ asset_id, cve_id, origin, note }) => await api.post('/api/cve-ack', { asset_id, cve_id, note, ...(origin ? { origin } : {}) }, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const unacknowledgeCve = async ({ asset_id, cve_id, origin }) => await api.delete('/api/cve-ack', {
    data: { asset_id, cve_id, ...(origin ? { origin } : {}) },
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const getBehaviors = async (payload) => await api.get('/api/tiresia/get-behaviors', {
    params: payload, 
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getLogsIp = async (payload, signal) => await api.get('/api/tiresia/get-logs-for-ip',{
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

export const getMachines = async (payload, signal) => await api.get('/api/agent/get-machine', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getAllLicenses = async (payload, signal) => await api.get('/api/agent/get-all-licenses', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getRaises = async (payload, signal) => await api.get('/api/config/get-raises', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})
export const manageSuppression = async (payload, signal) => await api.post('/api/config/manage-suppression', payload, {
    signal: signal,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const getConfig = async (payload, signal) => await api.get('/api/config/get-config', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})
export const getAssetInventoryConfig = async () => await api.get('/api/config/get-asset-inventory', {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' }
})
export const setAssetInventoryConfig = async (payload) => await api.post('/api/config/set-asset-inventory', payload, {
    timeout: 25000,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' }
})
export const setSyslog = async (payload) => await api.post('/api/config/set-syslog', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const resetSyslog = async (payload) => await api.post('/api/config/reset-syslog', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const setProxy = async (payload) => await api.post('/api/config/set-proxy', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const resetProxy = async (payload) => await api.post('/api/config/reset-proxy', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const setResponseIface = async (payload) => await api.post('/api/config/set-response-iface', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const resetResponseIface = async () => await api.post('/api/config/set-response-iface', { action: "reset" }, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
export const resetLecsNFR = async () => await api.post('/api/customers/nfr/reset-device', {}, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})
/* export const testProxy = async (payload) => await api.post('/api/config/test-proxy', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
}) */

export const getAgentData = async (payload, signal) => await api.get('/api/agent/get-data', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getTiresiaAnomalies = async (payload, signal) => await api.get('/api/tiresia/get-anomalies', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getTiresiaIpSummary = async (payload, signal) => await api.get('/api/tiresia/get-anomalies-ip-summary', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getAnomaliesEdgeStats = async (payload, signal) => await api.get('/api/tiresia/get-anomaliesEdgeStats', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const changeUserData = async (payload) => await api.post('/api/options/change-user-data', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getAllLecsOptions = async (payload, signal) => await api.get('/api/options/get-all-lecs', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getLicenses = async (payload, signal) => await api.get('/api/options/get-licenses', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const AddLicense = async (payload, signal) => await api.post('/api/options/add-license', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

export const getDeviceInfo = async (payload, signal) => await api.get('/api/options/get-device-info', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getTiresiaRarest = async (payload, signal) => await api.get('/api/options/get-rarest-tiresia', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const updateNotifyOffline = async (payload, signal) => await api.post('/api/options/update-notify-offline', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getLicensesReseller = async (type) => await api.get('/api/customers/get-licenses-reseller', {
    params: type,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const setOfflineNotify = async (payload, signal) => await api.post('/api/config/set-offline-notify', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getAuditByUser = async (payload) => await api.get('/api/options/get-auditByUser', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getNewAnomalies = async (payload, signal) => await api.get('/api/tiresia/get-new-anomalies', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const setBlacklist = async (payload) => await api.post('/api/config/set-blacklist', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})


export const getCodAttivazioneAgent = async (payload) => await api.get('/api/auth/getCodAttivazioneAgent', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getAggregations = async (payload) => await api.get('/api/aggregations/get-aggregations', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getCasesByInternalIp = async (payload) => await api.get('/api/aggregations/get-cases-by-internalIp', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const mondayCreateDealProtectionItem = async (payload, signal) => await api.post('/api/options/monday-created-deal-protection-item', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const mondayDeleteDealProtectionItem = async (payload, signal) => await api.post('/api/options/monday-delete-deal-protection-item', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const mondayUpdateDealProtectionItem = async (payload, signal) => await api.post('/api/options/monday-update-deal-protection-item', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getAccountMonday = async (payload) => await api.get('/api/options/get-account_monday', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getSecurityEventsByFlow_id = async (payload) => await api.get('/api/aggregations/get-security-events-by-flow_id', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getScans = async (payload) => await api.get('/api/tiresia/get-scans', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getLogsByDettaglio = async (payload) => await api.get('/api/tiresia/get-logs-by-dettaglio', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getAnomaliesCountByLecs = async (payload) => await api.get('/api/tiresia/get-anomalies-count-by-lecs', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getTiresiaLogsList = async (payload) => await api.get('/api/tiresia/get-tiresia-logs-list', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getRarestLogPairs = async (payload) => await api.get('api/tiresia/get-rarest-log-pairs', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getDnsCounts = async (payload) => await api.get('api/extra/dns-counts', {
    params: payload,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' }
})

export const getResellerOptions= async (payload) => await api.get('/api/options/get-reseller', {
    params: {},
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const changeResellerData = async (payload, signal) => await api.post('/api/options/change-reseller-data', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const setProfileImage = async (payload, signal) => await api.post('/api/options/set-profile-image', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const setSidebar = async (payload, signal) => await api.post('/api/options/set-sidebar', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getMatchAgentLecsNetwokAnomaly = async (payload, signal) => await api.get('/api/agent/get-match-agent-lecs-network-anomaly', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getAggregationsAccessFailed = async (payload, signal) => await api.get('/api/aggregations/get-aggregations-access-failed', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const setLecsName = async (payload, signal) => await api.post('/api/options/set-lecsName', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getLecsName = async (payload, signal) => await api.get('/api/options/get-lecsName', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})


export const getLicensesAgent = async (payload, signal) => await api.get('/api/agent/get-licenses-agent', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getOtLog =async (payload, signal) => await api.post('/api/ot-events/ot-log', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

// Conteggi per classe (badge delle tab della vista OT History)
export const getOtClassCounts = async (payload, signal) => await api.post('/api/ot-events/ot-class-counts', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

export const getOtStats = async (payload, signal) => await api.post('/api/ot-events/ot-stats', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

export const getOtSignals = async (payload = {}, signal) => await api.post('/api/ot-events/ot-signals', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

export const getOtComputeStats = async (payload, signal) => await api.post('/api/ot-events/ot-compute-stats', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

export const getOtSignalData = async (payload, signal) => await api.post('/api/ot-events/ot-signal-data', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

export const getOtActivityStats = async (payload, signal) => await api.post('/api/ot-events/ot-activity-stats', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
    signal: signal
})

// ─── OT Security Events ───────────────────────────────────────────────────────

export const getOtSecurityEvents = async (payload, signal) => await api.post('/api/ot-security/events', payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
    signal: signal
})

export const getOtSecurityStats = async (payload, signal) => await api.post('/api/ot-security/stats', payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
    signal: signal
})

export const getOtSecurityByIp = async (payload, signal) => await api.post('/api/ot-security/by-ip', payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
    signal: signal
})

export const setOtAckEvent = async (payload) => await api.post('/api/ot-security/ack-event', payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

// ─── OT Configurations ────────────────────────────────────────────────────────

export const getOtConfig = async (ip, protocol) => await api.get(`/api/ot-configurations/by-device`, {
    params: { ip, protocol },
    withCredentials: true,
})

export const getOtConfigTags = async (params) => await api.post(`/api/ot-configurations/tags`, params, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const getOtConfigs = async (params = {}) => await api.get('/api/ot-configurations', {
    withCredentials: true,
    params,
})

export const createOtConfig = async (payload) => await api.post('/api/ot-configurations', payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const updateOtConfig = async (ip, protocol, payload) => await api.put(`/api/ot-configurations/by-device`, { ip, protocol, ...payload }, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const deleteOtConfig = async (ip, protocol) => await api.delete(`/api/ot-configurations/by-device`, {
    params: { ip, protocol },
    withCredentials: true,
})

export const getOtSettings = async () => await api.get('/api/config/get-ot-settings', {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const getSystemConfig = async (scope, name) => await api.get('/api/system-configurations', {
    params: { scope, name },
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const setOtSettings = async (payload) => await api.post('/api/config/set-ot-settings', payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const setSeverityRules = async (rules) => await api.post('/api/config/set-severity-rules', { rules }, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const getNotificheOt = async () => await api.get('/api/config/get-notifiche-ot', {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const setNotificheOt = async (payload) => await api.post('/api/config/set-notifiche-ot', payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const getNotifications = async () => await api.get('/api/config/get-notifications', {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const setNotifications = async (payload) => await api.post('/api/config/set-notifications', payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const getLecsAccount = async (payload, signal) => await api.get('/api/home/get-lecs-account', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getDateTraining = async (payload, signal) => await api.get('/api/agent/get-date-training', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getAvgBps = async (payload, signal) => await api.get('/api/home/get-avg-bps', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getGraphAgent = async (payload, signal) => await api.get('/api/agent/get-graph-agent', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getIocDetection = async (payload, signal) => await api.get('/api/agent/get-ioc-detection', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getCriticalHighAgent = async (payload, signal) => await api.get('/api/agent/get-critical-high-agent', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getCriticalHighLecs = async (payload, signal) => await api.get('/api/home/get-critical-high-lecs', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})


export const getIocDetectionSelected = async (payload, signal) => await api.get('/api/agent/get-ioc-detection-selected', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getProducts = async (payload, signal) => await api.get('/api/auth/get-products', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getMatchAgentLecs = async (payload) => await api.get('/api/security/get-match-agent-lecs', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getMatchAgentLecsIoc = async (payload) => await api.get('/api/security/get-match-agent-lecs-ioc', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getMatchAgentLecsScan = async (payload) => await api.get('/api/security/get-match-agent-lecs-scan', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getAgentNetworkAnomalies = async (payload) => await api.get('/api/security/get-network-anomalies', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const getLicenseCodesAgent = async (payload) => await api.get('/api/agent/get-license-code-agent', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
})

export const downloadMsiAgent = async (payload) => await api.get('/api/agent/download-msi-agent', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    responseType: 'blob',
})

export const getSystemData = async (payload) => await api.get('/api/security/get-system-data', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const setBackgroundPdf = async (payload) => await api.post('/api/options/set-background-pdf', payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const getBackgroundPdf = async (payload) => await api.get('/api/options/get-background-pdf', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const deleteBackgroundPdf = async (payload) => await api.post('/api/options/delete-background-pdf', payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const getBackgroundTemplate = async () => await api.get('/api/options/get-reseller-background', {
    withCredentials: true,
    responseType: 'blob',
})

export const uploadBackgroundTemplate = async (formData) => await api.post('/api/options/upload-reseller-background', formData, {
    withCredentials: true,
    headers: {
        'Content-Type': 'multipart/form-data',
    },
})

export const deleteBackgroundTemplate = async () => await api.delete('/api/options/delete-reseller-background', {
    withCredentials: true,
})

export const getLogoTemplate = async () => await api.get('/api/options/get-reseller-logo', {
    withCredentials: true,
    responseType: 'blob',
})

export const uploadLogoTemplate = async (formData) => await api.post('/api/options/upload-reseller-logo', formData, {
    withCredentials: true,
    headers: {
        'Content-Type': 'multipart/form-data',
    },
})

export const deleteLogoTemplate = async () => await api.delete('/api/options/delete-reseller-logo', {
    withCredentials: true,
})

export const emailSupportDeleteLecs = async (payload) => await api.post('/api/options/email-support-delete-lecs', payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const generateReportJson = async (payload) => await api.post('/api/options/generate-report-json', payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const getOrionVisibility = async (payload) => await api.get('/api/assets/get-orion-visibility', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const setOrionVisibility = async (payload) => await api.post('/api/assets/set-orion-visibility', payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const updateNotificationTiresia = async (payload, signal) => await api.post('/api/options/update-notification-tiresia', payload, {
    withCredentials: true,
    headers: {
        'Content-Type': "application/json"
    },
    signal: signal
})

export const getNotificationTiresia = async (payload) => await api.get('/api/options/get-notification-tiresia', {
    params: payload,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

const apis = {
    getCsrfToken,
    login,
    logout,
    checkUser,
    get_lecs,
    set_lecs,
    get_user_options,
    get_home_graph,
    dataGrid_home,
    getLecsStatus,
    getLicense,
    getPercentile,
    getNotification,
    getRating,
    recordSecurityScoreHistory,
    getSecurityScoreHistory,
    getAlert,
    getAnomalies,
    getCritical,
    postTelegram,
    postCreateTicket,
    getDeviceOptions,
    getUserOptions,
    getHosts,
    getDelayed,
    postThreshold,
    getRealTime,
    getInfrastructure,
    getAnalysis,
    getBroadcast,
    getHighlights,
    getDataUsers,
    getInternalDetection,
    getInternalDetectionDetail,
    updateNotify,
    getThreatIntelligence,
    getThreatIntelligenceDetail,
    getTiresiaTrend,
    getTiresiaHighlights,
    getTiresiaEntropy,
    getTiresiaEntropyTable,
    getAnalysisDetail,
    getBroadcastDetail,
    getBroadcastLogs,
    getMap,
    getMapDetail,
    getIpList,
    getIpDetail,
    getConduits,
    getAssetExposure,
    getZoneConduits,
    getZoneStats,
    getHistoryTickets,
    getResellerInfo,
    post2FA,
    getResGlobalAttack,
    getNattackType,
    postSwitchToggle,
    getCustomers,
    postCurrentCustomer,
    postChangeName,
    getCustomerHighLights,
    getNFR,
    getVerifyPage,
    setCurrentCustomer,
    putCustomerDel,
    getTicketsRes,
    getCustomerTotalDet,
    getTicketsResDetail,
    postRegister,
    setProfileImage,
    reqForgotPassword,
    getPasswordResetPage,
    resetPassword,
    getDownloadPdf,
    postResend2FA,
    putNewLicense,
    putTicketState,
    postPrefHost,
    addLecs,
    getContentIA,
    getDetailCouple,
    getAdvancedData,
    getIpServices,
    postMachineHost,
    getHigh,
    getThreat,
    setTime,
    getTimeZone,
    getSecondaryAccount,
    addAccount,
    getResType,
    getIcosLecs,
    postAddIcosLecs,
    getIsolationForest,
    deleteSelectedLECS,
    getChangeLog,
    setChangeLog,
    getMaxMinPps,
    getMaxMinBps,
    getBpsGraphic,
    getIpInspection,
    getAllLecsView,
    setSuppLecs,
    getSuppRules,
    getClassificationOfIPByDetection,
    postSoppressEvent,
    getSingleDetailofType2and3,
    getSuppressedEventsofType2and3,
    delSuppressedEvent,
    getHighlightsHome,
    getSecurityLog,
    getIncidentsByIp,
    getSuppressionSuggestions,
    getSuppressionSuggestionDetail,
    getSuppressionSuggestionEvents,
    previewBulkAck,
    bulkAck,
    undoBulkAck,
    getNoiseFilters,
    saveNoiseFilters,
    getSingleHighOrCriticalDetail,
    getLecsInfoByReseller,
    setStaticIp,
    getAllLecsStatusReseller,
    getProtocolAnalyzer,
    setPrivacy,
    getPrivacy,
    generatePDFReseller,
    getHardwareTickets,
    createHardwareTickets,
    changeHardwareTicketPhases,
    askChangeLecs,
    setBackground,
    getProbeMode,
    getTiresia,
    getTiresiaLevel,
    getTiresiaNetwork,
    setWhitelist,
    getWhitelist,
    getAllIntelligenceReseller,
    getHeatMapData,
    getNotificationOfflineLecs,
    getAuthenticatorCode,
    //getNumberHost,
    activateLecs,
    getLocalAdmins,
    addAdminUser,
    delAdminUser,
    getWeeklyDataLecs,
    getLecsAccounts,
    updateLocalAdmin,
    getLogsBySerial,
    GetNetworkList,
    addLecsReseller,
    setAck,
    setAckEvent,
    getSettings,
    saveSettings,
    setProtection,
    getProtection,
    getCustomersLicenses,
    getLocalAdminLecs,
    addAccountLecs,
    delAccountLecs,
    deleteUser,
    getPayloadDetails,
    getTiresiaScans,
    getHighlightsIp,
    deleteTicket,
    deleteCustomer,
    updateCustomer,
    checkCommercial,
    changePassword,
    sendEmailPrivacy,
    chatBotAI,
    getNetworkHosts,
    getNetworkHostsV2,
    addInfoReport,
    checkInfoReport,
    updateInfoReport,
    AddImageReseller,
    GetImageReseller,
    checkCode,
    SendEmailCode,
    deleteInfoReport,
    getChartsData,
    setMachineName,
    updateAssetFields,
    orionManualOverride,
    getRecentHost,
    getNewDiscoveries,
    getZones,
    createZone,
    updateZone,
    deleteZone,
    assignZone,
    getConduitRules,
    createConduitRule,
    updateConduitRule,
    deleteConduitRule,
    pushOrionConfig,
    getCveAcks,
    acknowledgeCve,
    unacknowledgeCve,
    setPref,
    setMachine,
    deleteMachineName,
    getBehaviors,
    getLogsIp,
    getMachines,
    getAllLicenses,
    getRaises,
    manageSuppression,
    getConfig,
    setSyslog,
    resetSyslog,
    setProxy,
    resetProxy,
    setResponseIface,
    resetResponseIface,
    resetLecsNFR,
    getAgentData,
    getTiresiaAnomalies,
    getTiresiaIpSummary,
    changeUserData,
    getAllLecsOptions,
    getLicenses,
    AddLicense,
    getDeviceInfo,
    getTiresiaRarest,
    getAnomaliesEdgeStats,
    updateNotifyOffline,
    getLicensesReseller,
    setOfflineNotify,
    getAuditByUser,
    getOnlineLecs,
    getNewAnomalies,
    setBlacklist,
    getCodAttivazioneAgent,
    getAggregations,
    getCasesByInternalIp,
    mondayCreateDealProtectionItem,
    mondayDeleteDealProtectionItem,
    mondayUpdateDealProtectionItem,
    getAccountMonday,
    getSecurityEventsByFlow_id,
    getScans,
    getLogsByDettaglio,
    getAnomaliesCountByLecs,
    getTiresiaLogsList,
    getRarestLogPairs,
    getDnsCounts,
    getResellerOptions,
    changeResellerData,
    getMatchAgentLecsNetwokAnomaly,
    setSidebar,
    getAggregationsAccessFailed,
    setLecsName,
    getLecsName,
    getLicensesAgent,
    getOtLog,
    getOtClassCounts,
    getOtStats,
    getOtSignals,
    getOtComputeStats,
    getOtSignalData,
    getOtActivityStats,
    getOtSecurityEvents,
    getOtSecurityStats,
    getOtSecurityByIp,
    setOtAckEvent,
    getOtConfig,
    getOtConfigTags,
    getOtConfigs,
    createOtConfig,
    updateOtConfig,
    deleteOtConfig,
    getOtSettings,
    setOtSettings,
    getAssetInventoryConfig,
    setAssetInventoryConfig,
    setSeverityRules,
    getNotificheOt,
    setNotificheOt,
    getNotifications,
    setNotifications,
    getSystemConfig,
    getLecsAccount,
    getDateTraining,
    getAvgBps,
    getGraphAgent,
    getIocDetection,
    getCriticalHighAgent,
    getCriticalHighLecs,
    getIocDetectionSelected,
    getProducts,
    getMatchAgentLecs,
    getMatchAgentLecsIoc,
    getMatchAgentLecsScan,
    getAgentNetworkAnomalies,
    getLicenseCodesAgent,
    downloadMsiAgent,
    getSystemData,
    getExternalIps,
    setBackgroundPdf,
    getBackgroundPdf,
    deleteBackgroundPdf,
    getBackgroundTemplate,
    uploadBackgroundTemplate,
    deleteBackgroundTemplate,
    getLogoTemplate,
    uploadLogoTemplate,
    deleteLogoTemplate,
    getCustomerFeatures,
    emailSupportDeleteLecs,
    generateReportJson,
    getOrionVisibility,
    setOrionVisibility,
    uploadMib,
    getMibsForAsset,
    importAssets,
    saveMibFieldSelection,
    deleteMib,
    updateNotificationTiresia,
    getNotificationTiresia
    //testProxy
}

export default apis
